<template>
  <div id="app" class="application">
    <brand-bar></brand-bar>
    <router-view />
  </div>
</template>

<script>
import BrandBar from "@/components/BrandBar";

export default {
  components: { BrandBar }
};
</script>

<style lang="scss">
@import "@/scss/_all";

.application {
  height: calc(100vh - 87px);
}
</style>
